import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgZoomOut = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M660.48 733.184c-68.622 53.712-156.165 86.131-251.277 86.131-226.216 0-409.6-183.384-409.6-409.6s183.384-409.6 409.6-409.6c226.216 0 409.6 183.384 409.6 409.6 0 95.114-32.419 182.654-86.81 252.178l0.678-0.899 273.92 272.896-72.704 72.704-272.896-273.408zM409.6 716.8c169.662 0 307.2-137.538 307.2-307.2s-137.538-307.2-307.2-307.2v0c-169.662 0-307.2 137.538-307.2 307.2s137.538 307.2 307.2 307.2v0zM256 358.4h307.2v102.4h-307.2v-102.4z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgZoomOut);
export default ForwardRef;
